var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackdownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3732 4.6602L6.99998 8.9232L2.62673 4.6602C2.54859 4.58389 2.4437 4.54116 2.33447 4.54116C2.22525 4.54116 2.12036 4.58389 2.04223 4.6602C2.00439 4.69727 1.97434 4.74152 1.95382 4.79035C1.9333 4.83918 1.92273 4.89161 1.92273 4.94458C1.92273 4.99755 1.9333 5.04998 1.95382 5.09881C1.97434 5.14764 2.00439 5.19189 2.04223 5.22895L6.6946 9.76495C6.7763 9.84459 6.88588 9.88916 6.99998 9.88916C7.11407 9.88916 7.22365 9.84459 7.30535 9.76495L11.9577 5.22983C11.9958 5.19273 12.0261 5.14838 12.0468 5.09939C12.0675 5.05039 12.0781 4.99776 12.0781 4.94458C12.0781 4.8914 12.0675 4.83876 12.0468 4.78977C12.0261 4.74078 11.9958 4.69643 11.9577 4.65933C11.8796 4.58301 11.7747 4.54028 11.6655 4.54028C11.5563 4.54028 11.4514 4.58301 11.3732 4.65933V4.6602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackdownarrow);
export default __webpack_public_path__ + "static/media/stackdownarrow.e1ec40e7ed11108a64ae65f4689b75ae.svg";
export { ForwardRef as ReactComponent };